import React, { Component } from 'react'

export class DashboardCards extends Component {
  render() {
    const { orders, products, productsOnSale } = this.props
    const filteredProducts = products.filter(x => x.isVisible === true)
    const pendingOrders = orders.sort((a, b) => b.date.toDate() - a.date.toDate()).filter(x => x.status === 'pending')
    return (
      <div className="dashboard-cards">
        <div className="card">
          <p className="card-title">
            Products
          </p>
          <div className="card-body">
    <p>Visible <span>{filteredProducts.length}</span></p>
    <p>Total <span>{products.length}</span></p>
          </div>
        </div>
        <div className="card">
          <p className="card-title">
            Sale
          </p>
          <div className="card-body">
    <p>On sale <span>{productsOnSale.length}</span></p>
          </div>
        </div>
        <div className="card">
          <p className="card-title">
            Orders
          </p>
          <div className="card-body">
    <p>Pending <span>{pendingOrders.length}</span></p>
          </div>
        </div>
      </div>
    )
  }
}

export default DashboardCards
